import { useParams } from "react-router-dom";
import Breadcrumb from "../Pages/Breadcrumb";
import CalendarIcon from "../../assets/icons/new-icon.png";
import { useQuery } from '@tanstack/react-query';
import axios from "axios";
import Image from "../ui/Image";
import React from "react";
import Blogs from "./Blogs";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from 'react-i18next';

const BlogDetails = () => {
  const { t } = useTranslation();
  const { URL } = useLanguage();
  const { id } = useParams();

  const { data: blog, isLoading, error } = useQuery({
    queryKey: ['blog-details', id, URL],
    queryFn: async () => {
      const response = await axios.get(`${URL}/blogs/${id}`);
      if (response.status === 200) {
        return response?.data?.data || {};
      } else {
        throw new Error(t('custom.err'));
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
  });

  document.title = `${blog?.title || t('routes.blog-details')}`;

  if (error) {
    return (
      <div className="flex justify-center items-center relative z-50 bg-white">
        <p id="err">{error?.message || t('custom.err')}</p>
      </div>
    )
  };

  if (isLoading) {
    return (
      <>
        <div className="h-10 w-full l-load-dt"></div>
        <div className="l-load-p w-full space-y-2 px-20 py-8 max-lg:px-4">
          <div className="l-load-dt w-full h-[33rem] rounded-lg max-lg:h-96"></div>
          <div className="w-14 h-4 rounded-lg l-load-dt"></div>
          <div className="w-32 h-4 rounded-lg l-load-dt"></div>
        </div>
        <div className="space-y-2 mt-8 px-20 max-lg:px-4">
          {
            [...Array(8)].map((_, i) => (
              <div key={i} className="l-load-dt h-4 rounded-md w-full">

              </div>
            ))
          }
        </div>

      </>
    )
  };

  return (
    <>
      <Breadcrumb pages={[t("routes.all-blogs"), `${blog?.title || t("routes.blog-details") }`]} />

      <main className="container ">
        <section className=" rounded-md p-2">
        <div className="w-full h-[33rem] relative max-lg:h-full">
          <Image
            src={blog?.image}
            alt={blog?.title}
            className={"w-full h-full rounded-md"}
          />
        </div>
        <section className="space-y-4 mt-4" style={{border:'1px solid #C7C7C7',borderRadius:'10px',padding:'20px'}}>
          <div className="flex items-center gap-2 text-secondary-tw">
            <span>
              <img src={CalendarIcon} alt="icon" />
            </span>
            <span>
              {blog?.date || "22-12-2024"}
            </span>
          </div>
          <div className="space-y-4 text-start">
            <h2 className="text-2xl  font-black">{blog?.title}</h2>
            <article dangerouslySetInnerHTML={{ __html: blog?.description }} />
          </div>
        </section>
        </section>
        <Blogs/>
      </main>
    </>
  );
};

export default BlogDetails;
